import civilCeremonies from './../assets/images/Weddings/civilCeremonies.webp'

const CivilCeremonies = () => {
  return (
    <div className="flex flex-col md:flex-row items-center gap-8 p-6 md:p-12 bg-gray-100 rounded-xl shadow-lg mt-16">
      <img 
        src={civilCeremonies} 
        alt="Civil Ceremony" 
        className="w-full md:w-1/2 h-64 object-cover rounded-lg"
      />
      <div className="md:w-1/2 text-center md:text-left">
        <h2 className="text-3xl font-semibold text-gray-800 mb-4">Civil Ceremonies</h2>
        <p className="text-gray-600 mb-4">
          We are fully licensed for Civil Ceremonies, so you and your wedding party can enjoy a seamless experience
          without the need to coordinate travel between venues. This means you can relax and spend quality time
          together throughout the entire day.
        </p>
        <p className="text-gray-600 mb-4">
          Once you have made your provisional booking with us, we recommend contacting Staffordshire registrars as soon as possible.
          You can book your ceremony online via their website or call their registration team directly.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 mt-4">
          <a href="https://staffordshireceremonies.co.uk/" rel="noopener noreferrer" className="border-2 border-gray-700 text-gray-700 px-6 py-2 rounded-full hover:bg-gray-700 hover:text-white transition duration-300 shadow-md">
            Book Online
          </a>
          <a href="tel:03001118001" rel="noopener noreferrer" className="bg-gray-700 text-white px-6 py-2 rounded-full hover:bg-gray-800 transition duration-300 shadow-md">
            Call: 0300 111 8001
          </a>
        </div>
      </div>
    </div>
  );
};

export default CivilCeremonies;